<template>
  <div class="website">
    <span class="pointer" v-for="item in list" :key="item.id" @click="toLink(item.url)">{{ item.name }}</span>
  </div>
</template>

<script>
export default {
  name: '',
  props: [],
  components: {},
  data () {
    return {
      list: []
    }
  },
  activated () {},
  created () {},
  mounted () {
    this.loadData()
  },
  computed: {},
  methods: {
    loadData () {
      this.$axios.websiteList().then(res => {
        if (res) {
          this.list = res.data.data
        }
      })
    },
    toLink (url) {
      window.location.href = url
    }
  },
  watch: {}
}
</script>

<style scoped>
  .website {width: 1000px;height: 850px;border: 1px solid #DCDFE6;border-radius: 5px;padding: 30px;}
  .website span {display: inline-block;font-size: 12px;color: #333333;margin-right: 15px;margin-bottom: 30px;}
  .website span:hover {color: #76BF28;}
</style>



// WEBPACK FOOTER //
// src/pages/website/main.vue